// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.affiliates-manager {
  display: grid;
  gap: 1.5rem;
}

.affiliate-stat-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 0.75rem;
  margin-bottom: 0.75rem;
}

.affiliate-stat-grid > div {
  background: color-mix(in srgb, currentColor 5%, transparent);
  border: 1px solid color-mix(in srgb, currentColor 15%, transparent);
  border-radius: 0.5rem;
  padding: 0.85rem;
}

.affiliate-stat-grid span,
.affiliate-stat-grid strong,
.affiliate-codes-table small {
  display: block;
}

.affiliate-stat-grid span,
.affiliate-codes-table small {
  color: #66736d;
  font-size: 0.85rem;
}

.affiliate-stat-grid strong {
  font-size: 1.2rem;
  margin-top: 0.2rem;
}

.affiliate-status {
  border-radius: 999px;
  display: inline-block;
  font-size: 0.8rem;
  padding: 0.2rem 0.55rem;
  text-transform: capitalize;
}

.affiliate-status.active {
  background: #dff5e7;
  color: #185c32;
}

.affiliate-status.paused,
.affiliate-status.suspended {
  background: #f8e8d0;
  color: #704512;
}

.affiliate-table-actions,
.affiliate-form-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
}

.affiliate-offer-preview {
  flex-basis: 100%;
}

.affiliate-offer-preview {
  background: color-mix(in srgb, currentColor 4%, transparent);
  border-radius: 0.5rem;
  padding: 1rem;
}

.affiliate-offer-preview h3 {
  margin-top: 0;
}

.affiliate-referral-panel {
  margin-top: 1.5rem;
}

.affiliate-referral-form {
  max-width: 32rem;
}

@media (max-width: 700px) {
  .affiliate-stat-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Seller/Affiliates/Affiliates.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,4DAA4D;EAC5D,mEAAmE;EACnE,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;;EAEE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,iBAAiB;EACjB,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;EAEE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;EAEE,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,4DAA4D;EAC5D,qBAAqB;EACrB,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE;IACE,gDAAgD;EAClD;AACF","sourcesContent":[".affiliates-manager {\n  display: grid;\n  gap: 1.5rem;\n}\n\n.affiliate-stat-grid {\n  display: grid;\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n  gap: 0.75rem;\n  margin-bottom: 0.75rem;\n}\n\n.affiliate-stat-grid > div {\n  background: color-mix(in srgb, currentColor 5%, transparent);\n  border: 1px solid color-mix(in srgb, currentColor 15%, transparent);\n  border-radius: 0.5rem;\n  padding: 0.85rem;\n}\n\n.affiliate-stat-grid span,\n.affiliate-stat-grid strong,\n.affiliate-codes-table small {\n  display: block;\n}\n\n.affiliate-stat-grid span,\n.affiliate-codes-table small {\n  color: #66736d;\n  font-size: 0.85rem;\n}\n\n.affiliate-stat-grid strong {\n  font-size: 1.2rem;\n  margin-top: 0.2rem;\n}\n\n.affiliate-status {\n  border-radius: 999px;\n  display: inline-block;\n  font-size: 0.8rem;\n  padding: 0.2rem 0.55rem;\n  text-transform: capitalize;\n}\n\n.affiliate-status.active {\n  background: #dff5e7;\n  color: #185c32;\n}\n\n.affiliate-status.paused,\n.affiliate-status.suspended {\n  background: #f8e8d0;\n  color: #704512;\n}\n\n.affiliate-table-actions,\n.affiliate-form-actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n}\n\n.affiliate-offer-preview {\n  flex-basis: 100%;\n}\n\n.affiliate-offer-preview {\n  background: color-mix(in srgb, currentColor 4%, transparent);\n  border-radius: 0.5rem;\n  padding: 1rem;\n}\n\n.affiliate-offer-preview h3 {\n  margin-top: 0;\n}\n\n.affiliate-referral-panel {\n  margin-top: 1.5rem;\n}\n\n.affiliate-referral-form {\n  max-width: 32rem;\n}\n\n@media (max-width: 700px) {\n  .affiliate-stat-grid {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
